<!-- @format -->

<sis-tab-navigation #tabNavigation [wide]="'md'" [tabs]="tabs"></sis-tab-navigation>
